var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2719,
	"./chat-icon-bottom-nav-mobile.webp": 2720,
	"./home-icon-bottom-nav-mobile-active.webp": 2721,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2722,
	"./home-icon-bottom-nav-mobile.webp": 2723,
	"./home-icon-bottom-nav-mobile_b.webp": 2724,
	"./me-icon-bottom-nav-mobile-active.webp": 2725,
	"./me-icon-bottom-nav-mobile.webp": 2726,
	"./promo-icon-bottom-nav-mobile-active.webp": 2727,
	"./promo-icon-bottom-nav-mobile.webp": 2728,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2729,
	"./sponsor-icon-bottom-nav-mobile.webp": 2730,
	"./stream-icon-bottom-nav-mobile-active.webp": 2731,
	"./stream-icon-bottom-nav-mobile.webp": 2732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2718;